import { render, staticRenderFns } from "./ClientsTitle.vue?vue&type=template&id=0cf71316&scoped=true"
import script from "./ClientsTitle.vue?vue&type=script&lang=js"
export * from "./ClientsTitle.vue?vue&type=script&lang=js"
import style0 from "./ClientsTitle.vue?vue&type=style&index=0&id=0cf71316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf71316",
  null
  
)

export default component.exports